import { render, staticRenderFns } from "./edpBackendUser.vue?vue&type=template&id=0668bb10&"
import script from "./edpBackendUser.vue?vue&type=script&lang=js&"
export * from "./edpBackendUser.vue?vue&type=script&lang=js&"
import style0 from "./edpBackendUser.vue?vue&type=style&index=0&id=0668bb10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports